import { LoadScript } from '@react-google-maps/api';

import type { ReactNode } from 'react';
import React from 'react';

import { YMaps } from '@pbe/react-yandex-maps';

import { libraries } from '@/components/Map/MapGoogle.constants';

interface MapInitProps {
  children: ReactNode
}

const MapInit: React.FC<MapInitProps> = ({ children }) => {
  const isExportMode = process.env.MARKET === 'export';

  if ((isExportMode || process.env.DEFAULT_MAP === 'GOOGLE') && process.env.GOOGLE_API_KEY) {
    return (
      <LoadScript libraries={libraries} googleMapsApiKey={process.env.GOOGLE_API_KEY}>
        {children}
      </LoadScript>
    );
  }
  return (
    <YMaps query={{ apikey: process.env.YANDEX_API_KEY }}>
      {children}
    </YMaps>
  );
};

export default MapInit;
